module.exports = __webpack_public_path__ + "img/img-franquicias-restaurantes-multisucursal.9ccbe229.png";